var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"init":_vm.setting},model:{value:(_vm.editorData.content),callback:function ($$v) {_vm.$set(_vm.editorData, "content", $$v)},expression:"editorData.content"}})}
var staticRenderFns = []

export { render, staticRenderFns }